import DevToolsInfoWindow from "./devToolsInfoWindow";
export default DevToolsInfoWindow;
